<template>
  <VDropdown
      ref="dropdownRef"
      :shown="isOpen"
      :strategy="strategy"
      :auto-hide="false"
      :triggers="[]"
      :class="props.class"
      :popper-class="[popperClass, identifier, {'v-popper--theme-dark': darkMode}]"
      :distance="distance"
      :prevent-overflow="preventOverflow"
      :shift-cross-axis="shiftCrossAxis"
      :handle-resize="handleResize"
      :auto-size="autoSize"
      :auto-boundary-max-size="autoBoundaryMaxSize"
      :placement="placement"
      @hide="onClose"
      @show="onOpen"
  >
    <slot v-bind="{ open, close }" />

    <template #popper>
      <slot name="content" v-bind="{open, close}" />
    </template>
  </VDropdown>
</template>
<script setup>
import {onBeforeUnmount, onMounted, ref} from "vue";
import FloatingVue from 'floating-vue'
import {computed} from "vue";
import {useTheme} from "@/js/Plugins/Theme.js";

const emit = defineEmits(['open', 'close']);
const props = defineProps({
  strategy: {
    type: String,
    default: 'fixed'
  },
  popperClass: [String, Array, Object],
  distance: [Number],
  preventOverflow: {
    type: Boolean,
    default: true
  },
  handleResize: Boolean,
  shiftCrossAxis: Boolean,
  autoSize: Boolean,
  autoBoundaryMaxSize: Boolean,
  placement: String,
});
const theme = useTheme();
const dropdownRef = ref();
const isOpen = ref(false);
const identifier = generateIdentifier();
const darkMode = computed(() => theme.isDarkMode());

defineExpose({
  close,
  open,
});


onMounted(() => {
  if (!FloatingVue?.list) return;
  FloatingVue.list.push({
    id: identifier,
    el: dropdownRef.value.$el,
  });
});


onBeforeUnmount(() => {
  if (!FloatingVue?.list) return;
  const index = FloatingVue.list.findIndex(({ id }) => id === identifier);
  if (index === -1) return;
  FloatingVue.list.splice(index, 1);
});

function open() {
  isOpen.value = true;
  if (dropdownRef.value) {
    dropdownRef.value.show();
  }
}

function close() {
  isOpen.value = false;
  if (dropdownRef.value) {
    dropdownRef.value.hide();
  }
}

function onOpen() {
  document.addEventListener('mouseup', onClickOutside, true);
  emit('open');
}

function onClose() {
  document.removeEventListener('mouseup', onClickOutside, true);
  emit('close');
}

function onClickOutside(e) {
  if (dropdownRef.value && dropdownRef.value.$el && dropdownRef.value.$el.contains(e.target)) return;

  const popper = document.querySelector(`.${identifier}`);
  let shouldClose = true;

  if (popper && !popper.contains(e.target)) {
    FloatingVue.list.forEach(({ id, el }) => {
      const p = document.querySelector(`.${id}`);
      if (!el || id === identifier || !p || !p.contains(e.target)) return;
      if (popper.contains(el)) {
        shouldClose = false;
        return false;
      }
    });
  } else {
    shouldClose = false;
  }

  if (!shouldClose) return;
  close();
}

function generateIdentifier() {
  const chars = 'abcdefghijklmnopqrstuvwxyz';
  let result = '';
  for (let i = 0; i < 16; i++) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }
  return result;
}
</script>